import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import authService from "../../services/authService";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    organization: "",
    email: "",
    phoneNumber: "",
    comment: "",
  });
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const validateForm = () => {
    const { firstName, lastName, organization, email } = formData;
    if (!firstName || !lastName || !organization || !email || !recaptchaValue) {
      setErrorMessage(
        "Please fill in all required fields and complete the reCAPTCHA."
      );
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");
    try {
      await authService.contactUs(formData);
      setSuccessMessage(
        "Your message has been successfully sent. We will get back to you shortly."
      );
      setFormData({
        firstName: "",
        lastName: "",
        organization: "",
        email: "",
        phoneNumber: "",
        comment: "",
      });
      setRecaptchaValue(null);
    } catch (error) {
      setErrorMessage("Failed to send your message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="empty-space-my">
      <Row>
        <Col
          lg={6}
          className="d-flex flex-column justify-content-around bg-light px-5 rounded-start-4"
        >
          <div>
            <div className="purple-color righteousy-font">
              <span className="fs-four-title">Nouraa</span>
              <span className="fs-two">.ai</span>
            </div>
            <h1 className="fs-four-title anybody-font fw-bold my-4">
              Let’s talk About your Business
            </h1>
            <p className="text-muted">
              We’re here to help! Whether you have questions about our
              AI-powered services or need assistance, feel free to reach out.
              Our team is available 24/7 to support your business.
            </p>
          </div>
          <div>
            <p className="purple-color fw-bold fs-two mb-0">Contact us</p>
            <p className="fw-bold fs-two">1.630.355.6292</p>
          </div>
        </Col>

        <Col lg={6} className="ps-5">
          <Form onSubmit={handleSubmit}>
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            {successMessage && (
              <Alert variant="success">{successMessage}</Alert>
            )}
            <Row className="gap-5">
              <Col md={5}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold fs-one">
                    First Name*
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="custom-input"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={5}>
                <Form.Group className="mb-5">
                  <Form.Label className="fw-bold fs-one">Last Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="custom-input"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="gap-5">
              <Col md={5}>
                <Form.Group className="mb-5">
                  <Form.Label className="fw-bold fs-one">Email*</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="custom-input"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={5}>
                <Form.Group className="mb-5">
                  <Form.Label className="fw-bold fs-one">
                    Organisation*
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="organization"
                    value={formData.organization}
                    onChange={handleInputChange}
                    className="custom-input"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="gap-5">
              <Col md={5}>
                <Form.Group className="mb-5">
                  <Form.Label className="fw-bold fs-one">
                    Phone Number
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    className="custom-input"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-5">
              <Form.Label className="fw-bold fs-one">Comment</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                name="comment"
                value={formData.comment}
                onChange={handleInputChange}
                className="custom-input"
              />
            </Form.Group>

            <div className="mb-5 text-center">
              <ReCAPTCHA
                sitekey="6Lf7O-IqAAAAAHqIBVGeX566q_MqoRYC-v_4qui9"
                onChange={handleRecaptchaChange}
              />
            </div>

            <Button
              variant="none"
              className="btn-primary-style fs-one fw-bold py-3 px-5"
              type="submit"
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactForm;
